import { createSlice } from '@reduxjs/toolkit';
import { fetchExtAccountInvitations } from './action';

const initialState = {
  isLoading: true,
  data: [],
};

const { reducer } = createSlice({
  name: 'externalAccountInvitations',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchExtAccountInvitations.pending]: (state, { meta }) => {
      const { arg: { background = false } = {} } = meta;
      if (background) return;
      state.isLoading = true;
    },
    [fetchExtAccountInvitations.fulfilled]: (state, { payload }) => {
      state.data = payload?.data?.account_invitations || [];
      state.isLoading = false;
    },
  },
});

export default reducer;
